import { useCallback } from 'react';
import { LanguageService } from '../services/language.service';
import { commonTexts, tFunction } from '../services/texts.service';

/**
 * Custom hook for selecting language-specific text based on the current language.
 *
 * @example
 * ```tsx
 * const { t } = useTexts();
 * const greeting = t('Hej', 'Hello');
 * ```
 *
 * @returns Object containing translation helper function
 */
export const useTexts = () => {
  const currentLanguage = LanguageService.getCurrentLanguage();

  /**
   * Selects between Swedish and English values based on current language
   * @param swedishText - The Swedish translation
   * @param englishText - The English translation
   * @returns The value matching the current language (defaults to Swedish)
   */
  const t = useCallback(
    (swedishText: string, englishText: string): string => {
      return tFunction(swedishText, englishText, currentLanguage);
    },
    [currentLanguage]
  );

  return { t: Object.assign(t, commonTexts) };
};
